import { render, staticRenderFns } from "./MomoPayment.vue?vue&type=template&id=72915fc0&scoped=true"
import script from "./MomoPayment.vue?vue&type=script&lang=ts"
export * from "./MomoPayment.vue?vue&type=script&lang=ts"
import style0 from "./MomoPayment.vue?vue&type=style&index=0&id=72915fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72915fc0",
  null
  
)

export default component.exports